import {
  ChangeChannelRequest,
  DeliveryStatus,
  QuotationExchangeChannel,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export const selectableChannels = [
  QuotationExchangeChannel.Scsn,
  QuotationExchangeChannel.Manual,
] as const

export const readableLabel = (value?: string) =>
  value ? value.replace(/([a-z])([A-Z])/g, '$1 $2') : 'Not set'

export function createChannelRequest(
  channel: QuotationExchangeChannel,
): ChangeChannelRequest {
  if (channel === QuotationExchangeChannel.Email) {
    throw new Error('Email is not available until an exchange adapter exists.')
  }
  if (channel === QuotationExchangeChannel.Scsn) {
    return { channel }
  }

  return {
    channel,
    sender: {
      channel,
      address: undefined,
    },
    recipient: {
      channel,
      address: undefined,
    },
  }
}

export const canSend = (status?: DeliveryStatus) =>
  status === DeliveryStatus.NotStarted || canRetry(status)

export const canRetry = (status?: DeliveryStatus) =>
  status === DeliveryStatus.Failed ||
  status === DeliveryStatus.Sent ||
  status === DeliveryStatus.Delivered

export function errorMessage(error: unknown) {
  const appError = error as {
    status?: number
    message?: string
    validation?: Record<string, string | string[]>
  }
  if (appError.status === 401) return 'Your session has expired. Sign in again.'
  if (appError.status === 403)
    return 'You do not have contributor permission for this action.'
  const validation = appError.validation
    ? Object.values(appError.validation).flat().join(' ')
    : ''
  return validation || appError.message || 'The request could not be completed.'
}
